import React from "react";
import { Link } from "react-router-dom";

const WhyCard = ({ title, description, icon }) => {
  return (
    <div className=" group  border border-slate-200 group-hover:border-orange-500 w-52s p-5 bg-white hover:bg-orange-500 cursor-pointer shadow-sm  hover:shadow-xl transition-all duration-200 ">
      {icon}
      <h1 className=" pt-2 font-bold text-slate-900 group-hover:text-white">
        {title}
      </h1>
      <p className=" text-slate-800 text-sm py-5 group-hover:text-white">
        {description}
      </p>
    </div>
  );
};

export default WhyCard;
